let config = {
    // appName:'FunStory',
    // // appLogo:require('@/assets/images/logo.png').default,
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1599044136',
    // contactEmail:'funstory.cs@outlook.com',
    // copyright:'FunStory',
    // title:'FunStory',
    // facebookId:'310832607697750',
    // websiteUrl:'funstorys.com',
    // logoName:'funtel-logo',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1599044136',
    //     'appstore:bundle_id':'swbro.BookManager',
    //     'appstore:store_id':'1599044136'
    // }

    // appName:'Mobooks',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/za/app/id1615497181',
    // contactEmail:'mobooks.cs@outlook.com',
    // copyright:'Mobooks',
    // title:'Mobooks',
    // websiteUrl:'shepherdnovels.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/za/app/id1615497181',
    //     'appstore:bundle_id':'com.mobooks.novel',
    //     'appstore:store_id':'1615497181'
    // }

    // appName:'PandaReads',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/app/id1626427449',
    // contactEmail:'pandareads.cs@outlook.com',
    // copyright:'PandaReads',
    // title:'PandaReads',
    // websiteUrl:'pandareads.ficfunapp.com'

    // appName:'whatsreads',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1629004177',
    // contactEmail:'whatsread.cs@outlook.com',
    // copyright:'whatsreads',
    // title:'whatsreads',
    // websiteUrl:'whatsreads.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1629004177',
    //     'appstore:bundle_id':'com.webnovel.whatsread',
    //     'appstore:store_id':'1629004177'
    // }

    // appName:'Funtel',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1597216091',
    // contactEmail:'funtel.cs@outlook.com',
    // copyright:'Funtel',
    // title:'Funtel',
    // websiteUrl:'funtelnovel.com',
    // logoName:'funtel',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1597216091',
    //     'appstore:bundle_id':'funfic.novmic.com',
    //     'appstore:store_id':'1597216091'
    // },

    // appName:'Pocket eReader',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1629561758',
    // contactEmail:'pocket_ereader@163.com',
    // copyright:'Pocket eReader',
    // title:'Pocket eReader',
    // websiteUrl:'ereaderlab.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1629561758',
    //     'appstore:bundle_id':'com.pocket.ereader',
    //     'appstore:store_id':'1629561758'
    // },

    // appName:'eReader',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1580895095',
    // contactEmail:'ereader2022@163.com',
    // copyright:'eReader',
    // title:'eReader',
    // websiteUrl:'ereaderlab.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1580895095',
    //     'appstore:bundle_id':'com.kuaidu.reader',
    //     'appstore:store_id':'1580895095'
    // },

    // appName:'Readfic',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1612039188',
    // contactEmail:'readfic.cs@outlook.com',
    // copyright:'Readfic',
    // title:'Readfic',
    // websiteUrl:'readfic.com',
    // logoName:'redfic',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1612039188',
    //     'appstore:bundle_id':'com.readfic.novel',
    //     'appstore:store_id':'1612039188'
    // },

    // appName:'Sweet',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1630347934',
    // contactEmail:'sweetfic.cs@outlook.com',
    // copyright:'Sweet',
    // title:'Sweet',
    // websiteUrl:'sweetfic.com',
    // logoName:'Sweet',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1630347934',
    //     'appstore:bundle_id':'com.sweet.novel',
    //     'appstore:store_id':'1630347934'
    // },

    // appName:'TOPICKS',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1638288440',
    // contactEmail:'topicks.cs@outlook.com',
    // copyright:'TOPICKS',
    // title:'TOPICKS',
    // logoName:'Topicks',
    // websiteUrl:'topicksapp.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1638288440',
    //     'appstore:bundle_id':'com.topicks.novel',
    //     'appstore:store_id':'1638288440'
    // },

    // appName:'PopFic',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1596541746',
    // contactEmail:'popfic2021@163.com',
    // copyright:'PopFic',
    // title:'PopFic',
    // websiteUrl:'thepopfic.com',
    // logoName:'PopFic',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1596541746',
    //     'appstore:bundle_id':'com.cy.popfic.appstore',
    //     'appstore:store_id':'1596541746'
    // }

    // appName:'Pocket eBooks',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1636111360',
    // contactEmail:'pocket_ebooks@163.com',
    // copyright:'Pocket eBooks',
    // title:'Pocket eBooks',
    // websiteUrl:'pocketebooks.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1636111360',
    //     'appstore:bundle_id':'com.pocket.ebooks',
    //     'appstore:store_id':'1636111360'
    // }

    // appName:'Dreams',
    // googlePlayUrl:null,
    // // appStoreUrl:'https://apps.apple.com/us/app/id1636473927',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.dreams.novel',
    // contactEmail:'dreams.cs@outlook.com',
    // copyright:'Dreams',
    // title:'Dreams',
    // logoName:'Dreams',
    // websiteUrl:'dreamsnovel.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1636473927',
    //     'appstore:bundle_id':'com.dreams.novel',
    //     'appstore:store_id'  :'1636473927'
    // },

    // appName:'Good Fiction',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id6443874704',
    // contactEmail:'goodfic.cs@outlook.com',
    // copyright:'Good Fiction',
    // title:'Good Fiction',
    // websiteUrl:'goodfics.com',
    // logoName:'iosgoodfiction',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id6443874704',
    //     'appstore:bundle_id':'com.goodfiction.reader',
    //     'appstore:store_id':'6443874704'
    // },

    // 以下是确权新增的app

    // appName:'Webfiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.webfiction.reader',
    // appStoreUrl:null,
    // contactEmail:'webfiction@163.com',
    // copyright:'Webfiction',
    // title:'Webfiction',
    // logoName:'Webfiction',
    // fbid:'1296258547471052',
    // websiteUrl:'webfiction.crazyfic.com'

    // appName:'Free2Read',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.webnovel.free2read',
    // appStoreUrl:null,
    // contactEmail:'free2read.cs@outlook.com',
    // copyright:'Free2Read',
    // title:'Free2Read',
    // logoName:'Free2Read',
    // fbid:'420887282579363',
    // websiteUrl:'free2read.crazyfic.com'

    // appName:'FreeRead',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.free2read.novel',
    // appStoreUrl:null,
    // contactEmail:'freeread.cs@outlook.com',
    // copyright:'FreeRead',
    // title:'FreeRead',
    // logoName:'FreeRead',
    // fbid:'3074504019498792',
    // websiteUrl:'freeread.crazyfic.com'

    // appName:'Webstories',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.novelmanga.lite',
    // appStoreUrl:null,
    // contactEmail:'webstories.cs@outlook.com',
    // copyright:'Webstories',
    // title:'Webstories',
    // logoName:'Webstories',
    // fbid:'4631998320197740',
    // websiteUrl:'webstories.crazyfic.com'

    // appName:'ReadNow',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.readnow.novel',
    // appStoreUrl:null,
    // contactEmail:'readnow2021@163.com',
    // copyright:'ReadNow',
    // title:'ReadNow',
    // logoName:'ReadNow',
    // fbid:'401451608123845',
    // websiteUrl:'readnow.crazyfic.com'

    // appName:'HotNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.wordconnect.crushsaga',
    // appStoreUrl:null,
    // contactEmail:'hotnovel.cs@outlook.com',
    // copyright:'HotNovel',
    // title:'HotNovel',
    // logoName:'HotNovel',
    // fbid:'290108302725127',
    // websiteUrl:'hotnovel.crazyfic.com'

    // appName:'WeRead',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.novel.weread',
    // appStoreUrl:null,
    // contactEmail:'weread.cs@outlook.com',
    // copyright:'WeRead',
    // title:'WeRead',
    // logoName:'WeRead',
    // fbid:'1156600371462407',
    // websiteUrl:'weread.crazyfic.com'

    // appName:'Webnovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.webnovel.novel',
    // appStoreUrl:null,
    // contactEmail:'webnovel@yeah.net',
    // copyright:'Webnovel',
    // title:'Webnovel',
    // logoName:'Webnovel',
    // fbid:'1255781194873454',
    // websiteUrl:'webnovel.crazyfic.com'

    // appName:'GoodStory',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.goodstory.reader',
    // appStoreUrl:null,
    // contactEmail:'webgoodstory.cs@outlook.com',
    // copyright:'GoodStory',
    // title:'GoodStory',
    // logoName:'GoodStory',
    // fbid:'297457222456746',
    // websiteUrl:'webgoodstory.crazyfic.com'

    // appName:'Readme',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.novelmanga.readme',
    // appStoreUrl:null,
    // contactEmail:'readme.cs@outlook.com',
    // copyright:'Readme',
    // title:'Readme',
    // logoName:'Readme',
    // fbid:'280504523942762',
    // websiteUrl:'readme.crazyfic.com'

    // appName:'eReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.kuaidu.reader',
    // appStoreUrl:null,
    // contactEmail:'ereader2022@163.com',
    // copyright:'eReader',
    // title:'eReader',
    // logoName:'eReader-logo',
    // fbid:'274049691223955',
    // websiteUrl:'ereader.crazyfic.com'

    // appName:'Chapters',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.find.phone.gps.locator.location.tracker',
    // appStoreUrl:null,
    // contactEmail:'chapters.cs@hotmail.com',
    // copyright:'Chapters',
    // title:'Chapters',
    // logoName:'Chapters',
    // fbid:'913995656162063',
    // websiteUrl:'chaptersapps.com'

    // appName:'Romance Stories',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.romancestories.novel',
    // appStoreUrl:null,
    // contactEmail:'romance_stories@163.com',
    // copyright:'Romance Stories',
    // title:'Romance Stories',
    // logoName:'romancestories',
    // fbid:'597817818323570',
    // websiteUrl:'romancestories.crazyfic.com'

    // appName:'FunNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.luckygift.appcash',
    // appStoreUrl:null,
    // contactEmail:'funnovel.cs@outlook.com',
    // copyright:'FunNovel',
    // title:'FunNovel',
    // logoName:'FunNovel',
    // fbid:'2062221060603612',
    // websiteUrl:'funnovel.crazyfic.com'

    // appName:'Top Stories',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.buehistoria.reader',
    // appStoreUrl:null,
    // contactEmail:'topstories.cs@outlook.com',
    // copyright:'Top Stories',
    // title:'Top Stories',
    // logoName:'topstories',
    // fbid:'396475982169932',
    // websiteUrl:'topstories.crazyfic.com'

    // appName:'TopFic',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.webficcion.reader',
    // appStoreUrl:null,
    // contactEmail:'topfic.cs@outlook.com',
    // copyright:'TopFic',
    // title:'TopFic',
    // logoName:'TopFic',
    // fbid:'4611814962173927',
    // websiteUrl:'topfic.crazyfic.com'

    // appName:'SuperNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.luckygift.appgift',
    // appStoreUrl:null,
    // contactEmail:'supernovel.cs@outlook.com',
    // copyright:'SuperNovel',
    // title:'SuperNovel',
    // logoName:'SuperNovel',
    // fbid:'656571278806499',
    // websiteUrl:'supernovel.crazyfic.com'

    // appName:'NovelFox',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.luckygift.giftcard',
    // appStoreUrl:null,
    // contactEmail:'novelfox.cs@outlook.com',
    // copyright:'NovelFox',
    // title:'NovelFox',
    // logoName:'NovelFox',
    // fbid:'1005363113383044',
    // websiteUrl:'novelfox.crazyfic.com'

    // appName:'iNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.inovel.cheetah',
    // appStoreUrl:null,
    // contactEmail:'inovel2021@163.com',
    // copyright:'iNovel',
    // title:'iNovel',
    // logoName:'iNovel',
    // fbid:'3067792036842300',
    // websiteUrl:'inovel.crazyfic.com'

    // appName:'StoryHouse',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.superjoy.toyboxblast',
    // appStoreUrl:null,
    // contactEmail:'storyhouse.cs@outlook.com',
    // copyright:'StoryHouse',
    // title:'StoryHouse',
    // logoName:'StoryHouse',
    // fbid:'630843584819606',
    // websiteUrl:'storyhouse.crazyfic.com'

    // appName:'PopFic',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.popfic.novel',
    // appStoreUrl:null,
    // contactEmail:'popfic2021@163.com',
    // copyright:'PopFic',
    // title:'PopFic',
    // logoName:'PopFic',
    // fbid:'1010599932820944',
    // websiteUrl:'popfic.crazyfic.com'

    // appName:'Read4Fun',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.funplus.flashlight',
    // appStoreUrl:null,
    // contactEmail:'read4fun.cs@outlook.com',
    // copyright:'Read4Fun',
    // title:'Read4Fun',
    // logoName:'Read4Fun',
    // fbid:'431845205297111',
    // websiteUrl:'read4fun.crazyfic.com'

    // appName:'PopNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.luckygift.giftapp',
    // appStoreUrl:null,
    // contactEmail:'popnovel.cs@outlook.com',
    // copyright:'PopNovel',
    // title:'PopNovel',
    // logoName:'PopNovel',
    // fbid:'258537849746152',
    // websiteUrl:'popnovel.crazyfic.com'

    // appName:'FunFic',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.luckygift.cashmaster',
    // appStoreUrl:null,
    // contactEmail:'funfic.cs@outlook.com',
    // copyright:'FunFic',
    // title:'FunFic',
    // logoName:'FunFic',
    // fbid:'304000624917925',
    // websiteUrl:'funfic.crazyfic.com'

    // appName:'PopStories',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.popstories.novel',
    // appStoreUrl:null,
    // contactEmail:'popstories.dev@outlook.com',
    // copyright:'PopStories',
    // title:'PopStories',
    // logoName:'PopStories',
    // fbid:'270826618235663',
    // websiteUrl:'popstories.crazyfic.com'

    // appName:'BravoFiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.bravofiction.novel',
    // appStoreUrl:null,
    // contactEmail:'bravofiction.cs@outlook.com',
    // copyright:'BravoFiction',
    // title:'BravoFiction',
    // logoName:'BravoFiction',
    // fbid:'333305262038628',
    // websiteUrl:'bravofiction.crazyfic.com'

    // appName:'NovelNow',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.novelnow.novel',
    // appStoreUrl:null,
    // contactEmail:'novelnow.cs@outlook.com',
    // copyright:'NovelNow',
    // title:'NovelNow',
    // logoName:'NovelNow',
    // fbid:'477004257207403',
    // websiteUrl:'novelnowapp.com',

    // appName:'NovelWorld',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.novelworld.novel',
    // appStoreUrl:null,
    // contactEmail:'novelworld.cs@outlook.com',
    // copyright:'NovelWorld',
    // title:'NovelWorld',
    // logoName:'NovelWorld',
    // fbid:'791311995598055',
    // websiteUrl:'inovelsworld.com'

    // appName:'Podfic',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.giftapp.makemoney',
    // appStoreUrl:null,
    // contactEmail:'podfic.cs@outlook.com',
    // copyright:'Podfic',
    // title:'Podfic',
    // logoName:'Podfic',
    // fbid:'1673488889678485',
    // websiteUrl:'podfic.crazyfic.com'

    // appName:'Libfic',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.libfic.novel',
    // appStoreUrl:null,
    // contactEmail:'libfic.dev@outlook.com',
    // copyright:'Libfic',
    // title:'Libfic',
    // logoName:'Libfic',
    // fbid:'463799221984074',
    // websiteUrl:'libfic.libfic.com'

    // appName:'Mobooks',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.mobooks.novel',
    // appStoreUrl:null,
    // contactEmail:'mobooks.cs@outlook.com',
    // copyright:'Mobooks',
    // title:'Mobooks',
    // logoName:'Mobooks',
    // fbid:'2258464414302839',
    // websiteUrl:'mobooks.mobobooks.com'

    // appName:'LoveNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.lovenovel.tiger',
    // appStoreUrl:null,
    // contactEmail:'lovenovel.cs@outlook.com',
    // copyright:'LoveNovel',
    // title:'LoveNovel',
    // logoName:'LoveNovel',
    // fbid:'640771923828767',
    // websiteUrl:'lovenovelapps.com'

    // appName:'FICTLF',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.fictlf.novel',
    // appStoreUrl:null,
    // contactEmail:'fictlf.cs@outlook.com',
    // copyright:'FICTLF',
    // title:'FICTLF',
    // logoName:'FICTLF',
    // fbid:'459897592161920',
    // websiteUrl:'fictlf.romancezones.com'

    // appName:'StoryRover',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.story.rover',
    // appStoreUrl:null,
    // contactEmail:'storyrover.cs@outlook.com',
    // copyright:'StoryRover',
    // title:'StoryRover',
    // logoName:'StoryRover',
    // fbid:'1124673794769586',
    // websiteUrl:'storyrover.com'

    // appName:'Infinity Stories',
    //  googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1639261117',
    // contactEmail:'infinity.stories.cs@outlook.com',
    // copyright:'Infinity Stories',
    // title:'Infinity Stories',
    // websiteUrl:'infinitytale.com',
    // logoName:'infinitytale',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1639261117',
    //     'appstore:bundle_id':'com.infinitytale.novel',
    //     'appstore:store_id':'1639261117'
    // }

    // appName:'Liby',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1608863603',
    // contactEmail:'liby.cs@outlook.com',
    // copyright:'Liby',
    // title:'Liby',
    // logoName:'Liby',
    // websiteUrl:'libynovel.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1608863603',
    //     'appstore:bundle_id':'JKCount.www.com',
    //     'appstore:store_id':'1608863603'
    // },

    // appName:'iRomance',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1643862208',
    // contactEmail:'iromance.cs@outlook.com',
    // copyright:'iRomance',
    // title:'iRomance',
    // websiteUrl:'ireadnovels.com',
    // logoName:'iRomance',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1643862208',
    //     'appstore:bundle_id':'com.iromance.novel',
    //     'appstore:store_id':'1643862208'
    // },

    // appName:'Funfiction',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1643650823',
    // contactEmail:'funfic.cs@outlook.com',
    // copyright:'Funfiction',
    // title:'Funfiction',
    // websiteUrl:'ficfunapp.com',
    // logoName:'FicFun',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1643650823',
    //     'appstore:bundle_id':'com.funfiction.novel',
    //     'appstore:store_id':'1643650823'
    // },

    // appName:'Mynovel',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id6443462567',
    // contactEmail:'mynovel.cs@outlook.com',
    // copyright:'Mynovel',
    // title:'Mynovel',
    // websiteUrl:'menovels.com',
    // logoName:'MyNovel',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id6443462567',
    //     'appstore:bundle_id':'com.mynovel.tiger',
    //     'appstore:store_id':'6443462567'
    // },

    // appName:'iHear',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.ihear.audiobook',
    // appStoreUrl:'https://apps.apple.com/us/app/id6443486279',
    // contactEmail:'ihear.cs@outlook.com',
    // copyright:'iHear',
    // title:'iHear',
    // desc:'Hear yourself in audiobook utopia',
    // websiteUrl:'ihearlab.com',
    // fbid:'529781725507531',
    // logoName:'IHear',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id6443486279',
    //     'appstore:bundle_id':'com.ihear.audiobook',
    //     'appstore:store_id':'6443486279'
    // },

    // appName:'PocketeBooks',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.chatjoy.ch',
    // appStoreUrl:null,
    // contactEmail:'pocketebooks@outlook.com',
    // copyright:'PocketeBooks',
    // title:'PocketeBooks',
    // websiteUrl:'pocketebooks.crazyfic.com',
    // logoName:'PocketeBooks'

    // appName:'SuperFiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.super.fiction',
    // appStoreUrl:null,
    // contactEmail:'superfiction.cs@outlook.com',
    // copyright:'SuperFiction',
    // title:'SuperFiction',
    // template:'style2',
    // websiteUrl:'isuperfiction.com',
    // logoName:'SuperFiction'

    // appName:'GoodFiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.good.fiction',
    // appStoreUrl:null,
    // contactEmail:'goodfiction.cs@outlook.com',
    // copyright:'GoodFiction',
    // title:'GoodFiction',
    // websiteUrl:'goodfiction.crazyfic.com',
    // logoName:'GoodFiction'

    // appName: "StoryFM",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id6443824673",
    // contactEmail: "storyfm.cs@outlook.com",
    // copyright: "StoryFM",
    // title: "StoryFM",
    // websiteUrl: "istoryfm.com",
    // logoName: "storyfm",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id6443824673",
    //     "appstore:bundle_id": "com.storyfm.ios",
    //     "appstore:store_id": "6443824673",
    // },

    // appName: "StoryFM",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id6443824673",
    // contactEmail: "storyfm.cs@outlook.com",
    // copyright: "StoryFM",
    // title: "StoryFM",
    // websiteUrl: "podsfm.com",
    // logoName: "storyfm",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id6443824673",
    //     "appstore:bundle_id": "com.storyfm.ios",
    //     "appstore:store_id": "6443824673",
    // },

    // appName: "GoodStory",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id6443874239",
    // contactEmail: "goodstory.cs@outlook.com",
    // copyright: "GoodStory",
    // title: "GoodStory",
    // websiteUrl: "goodstoryapp.com",
    // logoName: "iosGoodStory",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id6443874239",
    //     "appstore:bundle_id": "com.goodstory.ereader",
    //     "appstore:store_id": "6443874239",
    // },

    // appName: "Webfiction",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id1543879690",
    // contactEmail: "webfiction@163.com",
    // copyright: "Webfiction",
    // title: "Webfiction",
    // websiteUrl: "webfictionapp.com",
    // logoName: "Webfiction",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id1543879690",
    //     "appstore:bundle_id": "com.novelcomics.lite",
    //     "appstore:store_id": "1543879690",
    // },


    // appName:'FicFun',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.juu.pixel3d.parallax3d.live.wallpaper.free.pro',
    // appStoreUrl:null,
    // contactEmail:'ficfun2022.cs@outlook.com',
    // copyright:'FicFun',
    // logoName:'android-FicFun',
    // title:'FicFun',
    // websiteUrl:'ficfunapp.com'


    // appName: "LoveRead",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id1641215303",
    // contactEmail: "Loveread.cs@hotmail.com",
    // copyright: "LoveRead",
    // title: "LoveRead",
    // websiteUrl: "weloveread.com",
    // logoName: "LoveRead",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id1641215303",
    //     "appstore:bundle_id": "com.lexiang.funbook",
    //     "appstore:store_id": "1641215303",
    // },

    // appName: "LoveRead",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id1641215303",
    // contactEmail: "Loveread.cs@hotmail.com",
    // copyright: "LoveRead",
    // title: "LoveRead",
    // websiteUrl: "weloveread.com",
    // template:'style2',
    // logoName: "LoveRead",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id1641215303",
    //     "appstore:bundle_id": "com.lexiang.funbook",
    //     "appstore:store_id": "1641215303",
    // },


    // appName:'KiwiReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.kiwi.reader',
    // appStoreUrl:null,
    // contactEmail:'kiwireader.cs@hotmail.com',
    // copyright:'KiwiReader',
    // logoName:'KiWiReader',
    // title:'KiwiReader',
    // template:'style2',
    // websiteUrl:'kiwireaders.com'

    //  appName:'Kiwi',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.kiwi.novel',
    // appStoreUrl:null,
    // contactEmail:'kiwireader.cs@hotmail.com',
    // copyright:'Kiwi',
    // logoName:'Kiwi',
    // title:'Kiwi',
    // template:'style2',
    // websiteUrl:'kiwireaders.com'

    //
    // appName: "Free2Read",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id6444358028",
    // contactEmail: "free2read.cs@outlook.com",
    // copyright: "Free2Read",
    // title: "Free2Read",
    // websiteUrl: "free2reads.com",
    // template:'style2',
    // logoName: "Free2Read",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id6444358028",
    //     "appstore:bundle_id": "com.free2read.novel",
    //     "appstore:store_id": "6444358028",
    // },

    // appName:'Cherry Fiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.cherry.fiction',
    // appStoreUrl:null,
    // contactEmail:'cherryfiction.cs@hotmail.com',
    // copyright:'Cherry Fiction',
    // logoName:'cherryfiction',
    // title:'cherryFiction',
    // facebookId:'534127538558486',
    // websiteUrl:'cherryfictions.com'


    // appName:'Litchi Fiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.litchi.fiction',
    // appStoreUrl:null,
    // contactEmail:'litchi.cs@hotmail.com',
    // copyright:'Litchi Fiction',
    // faceBookId:453162313616194,
    // logoName:'litchifiction',
    // title:'Litchi Fiction',
    // websiteUrl:'litchifiction.com'

    // appName:'MangoReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.grape.novel',
    // appStoreUrl:null,
    // contactEmail:'mangoreader.cs@hotmail.com',
    // copyright:'MangoReader',
    // faceBookId:1011262883163622,
    // logoName:'MangoReader',
    // title:'MangoReader',
    // template:'style2',
    // websiteUrl:'mangoreads.com'

    // appName:'Mango',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.mango.novel',
    // appStoreUrl:null,
    // contactEmail:'mangoreader.cs@hotmail.com',
    // copyright:'Mango',
    // faceBookId:172303618964406,
    // logoName:'Mango',
    // title:'Mango',
    // template:'style2',
    // websiteUrl:'mangoreads.com'

    // appName:'GrapeNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.grape.novel',
    // appStoreUrl:null,
    // contactEmail:'grapenovel.cs@hotmail.com',
    // copyright:'GrapeNovel',
    // faceBookId:3412363729027223,
    // logoName:'GrapeNovel',
    // title:'GrapeNovel',
    // // template:'style2',
    // websiteUrl:'grapenovels.com'

    // appName:'Pumpkin',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.pumpkin.fiction',
    // appStoreUrl:null,
    // contactEmail:'pumpkin.cs@outlook.com',
    // copyright:'Pumpkin',
    // faceBookId:1180671279521846,
    // logoName:'Pumpkin',
    // title:'Pumpkin',
    // template:'style2',
    // websiteUrl:'pumpkinovel.com'


    // appName:'Tomato',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.tomato.fiction',
    // appStoreUrl:null,
    // contactEmail:'tomatofiction.cs@outlook.com',
    // copyright:'Tomato',
    // faceBookId:2211556142380109,
    // logoName:'Tomato',
    // title:'Tomato',
    // // template:'style2',
    // websiteUrl:'tomatofiction.com'



    // appName:'OrangeReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.orange.reader',
    // appStoreUrl:null,
    // contactEmail:'orangereader.cs@hotmail.com',
    // copyright:'OrangeReader',
    // faceBookId:3359016614368048,
    // logoName:'OrangeReader',
    // title:'OrangeReader',
    // template:'style2',
    // websiteUrl:'orangereaders.com'

    // appName:'CornReading',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.corn.readings',
    // appStoreUrl:null,
    // contactEmail:'cornreader.cs@hotmail.com',
    // copyright:'CornReading',
    // faceBookId:522881023027035,
    // logoName:'CornReading',
    // title:'CornReading',
    // template:'style2',
    // websiteUrl:'cornreading.com'

    // appName:'Peanut Novel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.peanut.novel',
    // appStoreUrl:null,
    // contactEmail:'peanutnovel.cs@hotmail.com',
    // copyright:'Peanut Novel',
    // faceBookId:837821654119610,
    // logoName:'peanutnovel',
    // title:'Peanut Novel',
    // // template:'style2',
    // websiteUrl:'peanutnovel.com'


    // appName: "FancyNovel",
    // googlePlayUrl: "",
    // appStoreUrl: "https://apps.apple.com/us/app/id6444688314",
    // contactEmail: "fancynovel.cs@outlook.com",
    // copyright: "FancyNovel",
    // title: "FancyNovel",
    // websiteUrl: "fancynovels.com",
    // template:'style2',
    // facebookId:1259381078166548,
    // logoName: "FancyNovel",
    // headMeta: {
    //     "appstore:developer_url": "https://apps.apple.com/us/app/id6444688314",
    //     "appstore:bundle_id": "com.fancy.novel",
    //     "appstore:store_id": "6444688314",
    // },


    // appName:'CamelNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.camel.novel',
    // appStoreUrl:null,
    // contactEmail:'camelnovel.cs@hotmail.com',
    // copyright:'CamelNovel',
    // faceBookId:674432577458002,
    // logoName:'CamelNovel',
    // title:'CamelNovel',
    // template:'style2',
    // websiteUrl:'camelnovel.com'

    // appName:'FoxFics',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.fox.fics',
    // appStoreUrl:null,
    // contactEmail:'foxfics.cs@hotmail.com',
    // copyright:'FoxFics',
    // faceBookId:548678733358936,
    // logoName:'FoxFics',
    // title:'FoxFics',
    // // template:'style2',
    // websiteUrl:'foxfics.com'

    // appName:'Monkey',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.monkey.novel',
    // appStoreUrl:null,
    // contactEmail:'monkey.cs@outlook.com',
    // copyright:'Monkey',
    // faceBookId:1266626497214203,
    // logoName:'Monkey',
    // title:'Monkey',
    // template:'style2',
    // websiteUrl:'monekyreader.com'


    // appName:'DailyBooks',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.daily.books',
    // appStoreUrl:null,
    // contactEmail:'dailybooks.cs@outlook.com',
    // copyright:'DailyBooks',
    // title:'DailyBooks',
    // logoName:'DailyBooks',
    // fbid:'641972360325189',
    // template:'style2',
    // websiteUrl:'dailyibooks.com'


    // appName:'PandaReads',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.panda.reads',
    // appStoreUrl:null,
    // contactEmail:'pandareads.cs@hotmail.com',
    // copyright:'PandaReads',
    // title:'PandaReads',
    // logoName:'pandareads',
    // fbid:'506301061522178',
    // websiteUrl:'ipandareads.com'


    // appName:'FreeRead',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1658931180',
    // contactEmail:'freeread.cs@outlook.com',
    // copyright:'FreeRead',
    // title:'FreeRead',
    // logoName:'FreeRead',
    // websiteUrl:'freereadnovels.com',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1658931180',
    //     'appstore:bundle_id':'com.freeread.novel',
    //     'appstore:store_id':'1658931180'
    // },

    // appName:'Read4Fun',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1660694434',
    // contactEmail:'read4fun.cs@outlook.com',
    // copyright:'Read4Fun',
    // title:'Read4Fun',
    // logoName:'Read4Fun-ios',
    // websiteUrl:'read4funs.com',
    // fbid:'3364058177216925',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1660694434',
    //     'appstore:bundle_id':'com.read4fun.webnovel',
    //     'appstore:store_id':'1660694434'
    // },

    // appName:'LetsRead',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1633040270',
    // contactEmail:'letsread.cs@outlook.com',
    // copyright:'LetsRead',
    // title:'LetsRead',
    // logoName:'LetsRead',
    // websiteUrl:'letsreadnovel.com',
    // fbid:'507461307921318',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1633040270',
    //     'appstore:bundle_id':'com.ColorBook.tools',
    //     'appstore:store_id':'1633040270'
    // },

    // appName:'Webfm',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1543879690',
    // contactEmail:'webfiction@163.com',
    // copyright:'Webfm',
    // title:'Webfm',
    // logoName:'Webfm',
    // websiteUrl:'webfictionapp.com',
    // fbid:'725969765831845',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1543879690',
    //     'appstore:bundle_id':'com.novelcomics.lite',
    //     'appstore:store_id':'1543879690'
    // },

    // appName:'Webfm',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1543879690',
    // contactEmail:'webfm.cs@hotmail.com',
    // copyright:'Webfm',
    // title:'Webfm',
    // logoName:'Webfm',
    // websiteUrl:'mywebfm.com',
    // fbid:'725969765831845',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1543879690',
    //     'appstore:bundle_id':'com.novelcomics.lite',
    //     'appstore:store_id':'1543879690'
    // },


    // appName:'LionFiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.lion.fiction',
    // appStoreUrl:null,
    // contactEmail:'lionfiction.cs@hotmail.com',
    // copyright:'LionFiction',
    // title:'LionFiction',
    // logoName:'LionFiction',
    // fbid:'847904192993654',
    // template:'style2',
    // websiteUrl:'lionfiction.com'

    // appName:'Rabbit',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.rabbit.fiction',
    // appStoreUrl:null,
    // contactEmail:'rabbit.cs@outlook.com',
    // copyright:'Rabbit',
    // title:'Rabbit',
    // logoName:'Rabbit',
    // fbid:'466572938795455',
    // // template:'style2',
    // websiteUrl:'rabbitnovels.com'


    // appName:'iNovel',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1662193506',
    // contactEmail:'inovel2021@163.com',
    // copyright:'iNovel',
    // title:'iNovel',
    // logoName:'iNovel-ios',
    // websiteUrl:'iwebnovels.com',
    // fbid:'398323505815279',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1662193506',
    //     'appstore:bundle_id':'com.inovel.cheetah',
    //     'appstore:store_id':'1662193506'
    // },


    // appName:'Whatstory',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1665707773',
    // contactEmail:'whatstory.cs@hotmail.com',
    // copyright:'Whatstory',
    // title:'Whatstory',
    // logoName:'Whatstory',
    // websiteUrl:'whatstoryapp.com',
    // fbid:'564516432339687',
    // template:'style2',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1665707773',
    //     'appstore:bundle_id':'com.whatstory.webnovel',
    //     'appstore:store_id':'1665707773'
    // },

    // appName:'iToons',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.itoons.comics',
    // appStoreUrl:'https://apps.apple.com/it/app/id1662805388',
    // contactEmail:'itoons.cs@hootmail.com',
    // copyright:'iToons',
    // title:'iToons',
    // logoName:'iToons',
    // fbid:'734868068055924',
    // desc:'Best Binge-Worthy Comics for You!',
    // template:'style3',
    // websiteUrl:'itoonsapp.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/it/app/id1662805388',
    //     'appstore:bundle_id':'com.itoons.comics',
    //     'appstore:store_id':'1662805388'
    // },


    // appName:'DeerFiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.deer.fiction',
    // appStoreUrl:null,
    // contactEmail:'deerfiction.cs@hotmail.com',
    // copyright:'DeerFiction',
    // title:'DeerFiction',
    // logoName:'DeerFiction',
    // fbid:'476765241072033',
    // template:'style2',
    // websiteUrl:'deerfiction.com'

    // appName:'DolphinReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.dolphinreader.webnovel',
    // appStoreUrl:null,
    // contactEmail:'dolphinreader.cs@hotmail.com',
    // copyright:'DolphinReader',
    // title:'DolphinReader',
    // logoName:'DolphinReader',
    // fbid:'6148506625179591',
    // template:'style2',
    // websiteUrl:'dolphinreaders.com'


    // appName:'HippoNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.hippo.novel',
    // appStoreUrl:null,
    // contactEmail:'hipponovel.cs@outlook.com',
    // copyright:'HippoNovel',
    // title:'HippoNovel',
    // logoName:'HippoNovel',
    // fbid:'460588019441967',
    // template:'style2',
    // websiteUrl:'hipponovel.com'

    // appName:'TigerReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.hippo.novel',
    // appStoreUrl:null,
    // contactEmail:'tigerreader.cs@hotmail.com',
    // copyright:'TigerReader',
    // title:'TigerReader',
    // logoName:'TigerReader',
    // fbid:'579815037330129',
    // // template:'style2',
    // websiteUrl:'tigereaders.com'


    // appName:'Pocketoons',
    // appStoreUrl:'https://apps.apple.com/it/app/id1662805388',
    // contactEmail:'pocketoons.cs@hotmail.com',
    // copyright:'Pocketoons',
    // title:'Pocketoons',
    // logoName:'Pocketoons',
    // fbid:'724726106011499',
    // desc:'Best Binge-Worthy Comics for You!',
    // template:'style3',
    // websiteUrl:'pocketons.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/it/app/id1662805388',
    //     'appstore:bundle_id':'com.itoons.comics',
    //     'appstore:store_id':'1662805388'
    // },

    // appName:'Listenow',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.audio.listenow',
    // appStoreUrl:'',
    // contactEmail:'listenow.cs@hotmail.com',
    // copyright:'Listenow',
    // title:'Listenow',
    // desc:'Hear yourself in audiobook utopia',
    // websiteUrl:'listenowapp.com',
    // fbid:'1213386662881579',
    // logoName:'Listenow'


    // appName:'iAudios',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.story.iaudios',
    // appStoreUrl:'',
    // contactEmail:'iaudios.cs@hotmail.com',
    // copyright:'iAudios',
    // title:'iAudios',
    // desc:'Hear yourself in audiobook utopia',
    // websiteUrl:'iaudioapp.com',
    // fbid:'3405512273097618',
    // logoName:'iAudios'


    // appName:'GoodToon',
    // appStoreUrl:'https://apps.apple.com/it/app/id1662805388',
    // contactEmail:'goodtoon.cs@hotmail.com',
    // copyright:'GoodToon',
    // title:'GoodToon',
    // logoName:'GoodToon',
    // fbid:'724726106011499',
    // desc:'Best Binge-Worthy Comics for You!',
    // template:'style3',
    // websiteUrl:'goodtoonapp.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/it/app/id1662805388',
    //     'appstore:bundle_id':'com.itoons.comics',
    //     'appstore:store_id':'1662805388'
    // },

    // appName:'Tellstory',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.audible.tellstory',
    // appStoreUrl:'',
    // contactEmail:'tellstory.cs@hotmail.com',
    // copyright:'Tellstory',
    // title:'Tellstory',
    // desc:'Hear yourself in audiobook utopia',
    // websiteUrl:'tellstoryapp.com',
    // fbid:'597257565195480',
    // template:'style2',
    // logoName:'Tellstory'

    // appName:'eAudioBooks',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.fm.eaudiobooks',
    // appStoreUrl:'',
    // contactEmail:'eaudiobooks.cs@hotmail.com',
    // copyright:'eAudioBooks',
    // title:'eAudioBooks',
    // desc:'Hear yourself in audiobook utopia',
    // websiteUrl:'eaudioapp.com',
    // fbid:'759889388891155',
    // // template:'style2',
    // logoName:'eAudioBooks'

    // appName:'FoxFm',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.audiobooks.foxfom',
    // appStoreUrl:'',
    // contactEmail:'foxfm.cs@hotmail.com',
    // copyright:'FoxFm',
    // title:'FoxFm',
    // desc:'Hear yourself in audiobook utopia',
    // websiteUrl:'foxfmapp.com',
    // fbid:'864493517992877',
    // // template:'style2',
    // logoName:'FoxFm'

    // appName:'Starfish Fiction',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.strafish.fiction',
    // appStoreUrl:'',
    // contactEmail:'starfishfiction.cs@hotmail.com',
    // copyright:'Starfish Fiction',
    // title:'Starfish Fiction',
    // websiteUrl:'starfishfic.com',
    // fbid:'743353523845791',
    // logoName:'StarfishFiction'

    // appName:'Sealread',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.seal.read',
    // appStoreUrl:'',
    // contactEmail:'sealread.cs@hotmail.com',
    // copyright:'Sealread',
    // title:'Sealread',
    // websiteUrl:'sealreads.com',
    // template:'style2',
    // fbid:'6148986905183836',
    // logoName:'Sealread'

    // appName:'Shark Novels',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.shark.novels',
    // appStoreUrl:'',
    // contactEmail:'sharknovels.cs@hotmail.com',
    // copyright:'Shark Novels',
    // title:'Shark Novels',
    // websiteUrl:'sharknovel.com',
    // // template:'style2',
    // fbid:'178181718339863',
    // logoName:'SharkNovels'

    // appName:'CoralReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.coral.reader',
    // appStoreUrl:null,
    // contactEmail:'coralreader.cs@hotmail.com',
    // copyright:'CoralReader',
    // faceBookId:218110184220806,
    // logoName:'CoralReader',
    // title:'CoralReader',
    // template:'style2',
    // websiteUrl:'coralreader.com'

    // appName:'WeJoy',
    // googlePlayUrl:'',
    // appStoreUrl:'https://apps.apple.com/us/app/id6446987007',
    // contactEmail:'wejoy.cs@hotmail.com',
    // copyright:'WeJoy',
    // logoName:'WeJoy',
    // desc:'Enjoy a New Wallpaper Daily',
    // title:'WeJoy',
    // template:'style2',
    // websiteUrl:'wereadjoy.com'


    // appName:'Octopus',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.octopus.novel',
    // appStoreUrl:'',
    // contactEmail:'octopus.cs@hotmail.com',
    // copyright:'Octopus',
    // logoName:'Octopus',
    // title:'Octopus',
    // fbid:'128544420179081',
    // template:'style2',
    // websiteUrl:'octopusnovel.com'


    // appName:'GreatNovel',
    // appStoreUrl:'https://apps.apple.com/it/app/id1613505343',
    // contactEmail:'greatnovel.cs@outlook.com',
    // copyright:'GreatNovel',
    // title:'GreatNovel',
    // logoName:'greatnovel',
    // fbid:'494870435276575',
    // template:'style4',
    // websiteUrl:'great-novel.com',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/it/app/id1613505343',
    //     'appstore:bundle_id':'com.greatnovel.readerlab',
    //     'appstore:store_id':'1613505343'
    // },


    // appName:'Seagull',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.seagull.reads',
    // appStoreUrl:'',
    // contactEmail:'seagull.cs@outlook.com',
    // copyright:'Seagull',
    // title:'Seagull',
    // logoName:'Seagull',
    // websiteUrl:'seagullab.com',
    // template:'style4',
    // fbid:'607406064304102',


    // appName:'SnailReads',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.snail.reads',
    // appStoreUrl:'',
    // contactEmail:'snailreads.cs@hotmail.com',
    // copyright:'SnailReads',
    // title:'SnailReads',
    // logoName:'SnailReads',
    // websiteUrl:'snailreads.com',
    // template:'style2',
    // fbid:'1020193208868017',

    // appName:'vampire Novels',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.vampire.novels',
    // appStoreUrl:'',
    // contactEmail:'vampirenovel.cs@hotmail.com',
    // copyright:'vampire Novels',
    // title:'vampire Novels',
    // logoName:'VampireNovels',
    // websiteUrl:'vampirefictions.com',
    // // template:'style4',
    // fbid:'755256859573197',

    // appName:'OwlReader',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.owl.reader',
    // appStoreUrl:'',
    // contactEmail:'owlreader.cs@hotmail.com',
    // copyright:'OwlReader',
    // title:'OwlReader',
    // logoName:'OwlReader',
    // websiteUrl:'owlreaderapp.com',
    // template:'style2',
    // fbid:'256450373406352',


    // appName:'HitNovel',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.hitnovel.reader',
    // appStoreUrl:'https://apps.apple.com/us/app/id6449247784',
    // contactEmail:'hitnovel.cs@hotmail.com',
    // copyright:'HitNovel',
    // title:'HitNovel',
    // logoName:'HitNovel',
    // websiteUrl:'hitnovelapp.com',
    // template:'style2',
    // fbid:'905566600548534',
    //  headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id6449247784',
    //     'appstore:bundle_id':'com.hitnovel.reader',
    //     'appstore:store_id':'6449247784'
    // },

    // appName:'Werewolf Novels',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.werewolf.novels',
    // appStoreUrl:'',
    // contactEmail:'werewolfnovels.cs@hotmail.com',
    // copyright:'Werewolf Novels',
    // title:'Werewolf Novels',
    // logoName:'werewolfnovels',
    // websiteUrl:'werewolfnovels.com',
    // // template:'style2',
    // fbid:'215124157830302',

    // appName:'Shepherd Novel',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1420995439',
    // contactEmail:'shepherd.cs@hotmail.com',
    // copyright:'Shepherd Novel',
    // title:'Shepherd Novel',
    // logoName:'Shepherd',
    // websiteUrl:'shepherdsapp.com',
    // fbid:'219893240102595',
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1420995439',
    //     'appstore:bundle_id':'com.nk.sheepStory',
    //     'appstore:store_id':'1420995439'
    // },

    // appName:'Readify',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.readify.novel',
    // appStoreUrl:'',
    // contactEmail:'readify.cs@hotmail.com',
    // copyright:'Readify',
    // title:'Readify',
    // logoName:'Readify',
    // websiteUrl:'readifyapp.com',
    // template:'style2',
    // fbid:'248947567641474',

    // appName:'StorySpot',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.storyspot.novel',
    // appStoreUrl:'',
    // contactEmail:'storyspot.cs@hotmail.com',
    // copyright:'StorySpot',
    // title:'StorySpot',
    // logoName:'StorySpot',
    // websiteUrl:'storiesspot.com',
    // template:'style2',
    // fbid:'732119855376706',

    // appName:'TaleTrek',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.taletrek.fiction',
    // appStoreUrl:'',
    // contactEmail:'taletrek.cs@outlook.com',
    // copyright:'TaleTrek',
    // title:'TaleTrek',
    // logoName:'TaleTrek',
    // websiteUrl:'taletreks.com',![](../../../../FictionFlow.png)
    // template:'style4',
    // fbid:'1430390887715790',

    // appName:'FictionFlow',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.fictionflow.reader',
    // appStoreUrl:'',
    // contactEmail:'fictionflow@outlook.com',
    // copyright:'FictionFlow',
    // title:'FictionFlow',
    // logoName:'FictionFlow',
    // websiteUrl:'fictionsflow.com',
    // template:'style2',
    // fbid:'3348964722033788',

    // appName:'TapRead',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.tapread.novel',
    // appStoreUrl:'',
    // contactEmail:'tapread.cs@hotmail.com',
    // copyright:'TapRead',
    // title:'TapRead',
    // logoName:'TapRead',
    // websiteUrl:'tap2reads.com',
    // template:'style2',
    // fbid:'757673849416002',


    // appName:'Gonovel',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id6449522854',
    // contactEmail:'gonovel.cs@hotmail.com',
    // copyright:'Gonovel',
    // title:'Gonovel',
    // logoName:'Gonovel',
    // template:'style2',
    // websiteUrl:'gonovelapp.com',
    // fbid:'752248773066560',
    // hasMemberShip:true, // 有会员页
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id6449522854',
    //     'appstore:bundle_id':'com.gonovel.reader',
    //     'appstore:store_id':'6449522854'
    // },

    // appName:'Booknet',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.booknet.fiction',
    // appStoreUrl:'',
    // contactEmail:'booknet.cs@hotmail.com',
    // copyright:'Booknet',
    // title:'Booknet',
    // logoName:'Booknet',
    // websiteUrl:'booknetapp.com',
    // template:'style2',
    // fbid:'217698307649575',

    // appName:'NovelZone',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.webnovel.zone',
    // appStoreUrl:'',
    // contactEmail:'novelzone.cs@hotmail.com',
    // copyright:'NovelZone',
    // title:'NovelZone',
    // logoName:'NovelZone',
    // websiteUrl:'novelzoneapp.com',
    // template:'style2',
    // fbid:'3141054356194459',

    // appName:'StorySphere',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.storysphere.fiction',
    // appStoreUrl:'',
    // contactEmail:'storysphereapp@outlook.com',
    // copyright:'StorySphere',
    // title:'StorySphere',
    // logoName:'StorySphere',
    // websiteUrl:'mystorysphere.com',
    // template:'style2',
    // fbid:'270351662079984',


    // appName:'iComics',
    // googlePlayUrl:null,
    // appStoreUrl:'https://apps.apple.com/us/app/id1585804240',
    // contactEmail:'icomics_cs@hotmail.com',
    // copyright:'iComics',
    // title:'iComics',
    // logoName:'iComics',
    // template:'style2',
    // websiteUrl:'icomicapp.com',
    // fbid:'1202273256948322',
    // hasMemberShip:true, // 有会员页
    // headMeta:{
    //     'appstore:developer_url':'https://apps.apple.com/us/app/id1585804240',
    //     'appstore:bundle_id':'com.kuaikan.comics',
    //     'appstore:store_id':'1585804240'
    // },

    // appName:'Inkwell',
    // googlePlayUrl:'https://play.google.com/store/apps/details?id=com.inkwell.reader',
    // appStoreUrl:'',
    // contactEmail:'Inkwell.cs@hotmail.com',
    // copyright:'Inkwell',
    // title:'Inkwell',
    // logoName:'Inkwell',
    // websiteUrl:'inkwellapps.com',
    // template:'style2',
    // fbid:'1603522480133091',

    appName:'Mebooks',
    googlePlayUrl:'https://play.google.com/store/apps/details?id=com.mebooks.webnovel',
    appStoreUrl:'',
    contactEmail:'mebooksapp@outlook.com',
    copyright:'Mebooks',
    title:'Mebooks',
    logoName:'Mebooks',
    websiteUrl:'mebooksapp.com',
    template:'style2',
    fbid:'642670770734866',
};

export default config;
